import type ColumnOption from "../../../../../interfaces/columnOptions";

export enum Columns {
  Title = "title",
  Subject = "subject",
  Status = "status",
  Modified = "modified",
  Added = "added",
  Sent = "sent",
}

const columnOptions: Array<ColumnOption> = [
  {
    name: "Title",
    width: 3,
    isSortable: true,
  },
  {
    name: "Subject",
    width: 3,
    isSortable: true,
  },
  {
    name: "Sent",
    width: 2,
    isSortable: false,
  },
  {
    name: "Added",
    width: 2,
    isSortable: true,
  },
  {
    name: "Modified",
    width: 2,
    isSortable: true,
  },
  {
    name: "Status",
    width: 2,
    isSortable: true,
  },
  {
    name: "",
    width: 1,
    isSortable: false,
  },
];

export default columnOptions;
